import {
    errorFetchingRequestState,
    getInitialRequestState, RequestState,
    RequestStateProp,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {ProjectDetail, ProjectListItem} from "../../models/projects/Project";
import {
    DELETE_PROJECT,
    DELETE_PROJECT_ERROR,
    DELETE_PROJECT_SUCCESS,
    FETCH_PROJECT_BY_ID,
    FETCH_PROJECT_BY_ID_ERROR,
    FETCH_PROJECT_BY_ID_SUCCESS,
    FETCH_PROJECTS,
    FETCH_PROJECTS_ERROR,
    FETCH_PROJECTS_SUCCESS, PROJECT_FORM_STATE_CACHE_RESET,
    PROJECT_FORM_STATE_TO_CACHE,
    ProjectViewActionTypes,
    RESTORE_PROJECT,
    RESTORE_PROJECT_ERROR,
    RESTORE_PROJECT_SUCCESS
} from "../../actions/projects/ProjectActions";
import {Nullable} from "../../models/common/Nullable";
import {
    UPDATE_PHASE_PERFORMANCE,
    UPDATE_PHASE_PERFORMANCE_ERROR,
    UPDATE_PHASE_PERFORMANCE_SUCCESS,
    UpdatePhasePerformanceActionTypes
} from "../../actions/projects/ProjectStagePhaseActions";
import {
    FETCH_PROJECT_TIMESHEET,
    FETCH_PROJECT_TIMESHEET_ERROR,
    FETCH_PROJECT_TIMESHEET_SUCCESS,
    FetchProjectTimesheetActionTypes
} from "../../actions/projects/ProjectTimesheetActions";
import {isProjectStage, ProjectStage} from "../../models/projects/ProjectStage";
import {isProjectStagePhase, ProjectStagePhase} from "../../models/projects/ProjectStagePhase";
import {projectFormInitialState, ProjectFormViewState} from "../../components/projects/form/ProjectFormView";
import {ApiReturnType} from "../../models/common/ApiReturnType";
import {TimesheetEntryProject} from "../../models/timesheet/Timesheet";


export interface ProjectState extends RequestStateProp {
    totalEntries: number
    projects: Nullable< ProjectListItem[] >
    detailedProjects: {
        [ key: number ]: Nullable< ProjectDetail >
    }
    formStateCache: Nullable< ProjectFormViewState >
    resetForm: boolean
    projectTimesheet: ApiReturnType< Nullable< TimesheetEntryProject[] > >
    timesheetRequest: RequestState

}

const initialState: ProjectState = {
    totalEntries: 0,
    projects: [],
    detailedProjects: {},

    request: getInitialRequestState(),
    timesheetRequest: getInitialRequestState(),
    projectTimesheet: { entries: null, totalEntries: 0 },
    formStateCache: null,
    resetForm: false
};


export function ProjectReducer(
    state = initialState,
    action: ProjectViewActionTypes | UpdatePhasePerformanceActionTypes | FetchProjectTimesheetActionTypes
) {

    switch( action.type ) {
        case PROJECT_FORM_STATE_TO_CACHE:
            return {
                ...state,
                formStateCache: action.formState,
                resetForm: false
            };
        case PROJECT_FORM_STATE_CACHE_RESET:
            return {
                ...state,
                formStateCache: null,
                resetForm: true
            };
        case FETCH_PROJECTS:
            return {
                ...state,
                projects: [],
                request: startFetchingRequestState()
            };
        case FETCH_PROJECTS_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error)
            };
        case FETCH_PROJECTS_SUCCESS:
            return {
                ...state,
                projects: action.payload.entries,
                totalEntries: action.payload.totalEntries,
                request: successFetchingRequestState()
            };
        case FETCH_PROJECT_BY_ID:
            return {
                ...state,
                detailedProjects: {
                    ...state.detailedProjects,
                    [ action.projectId.rawValue ]: null
                },
                request: startFetchingRequestState()
            };
        case FETCH_PROJECT_BY_ID_SUCCESS:
            return {
                ...state,
                detailedProjects: {
                    ...state.detailedProjects,
                    [ action.projectId.rawValue ]: {
                        ...state.detailedProjects[ action.projectId.rawValue ],
                        project: action.payload,
                        projectLeads: [],
                        projectTimesheet: { totalEntries: 0, entries: null }
                    }
                },
                request: successFetchingRequestState()
            };
        case FETCH_PROJECT_TIMESHEET:
            return {
                ...state,
                projectTimesheet: {
                    totalEntries: 0,
                    entries: null
                },
                timesheetRequest: startFetchingRequestState()
            };
        case FETCH_PROJECT_TIMESHEET_SUCCESS:
            return {
                ...state,
                projectTimesheet: action.payload,
                timesheetRequest: successFetchingRequestState()
            };
        case FETCH_PROJECT_TIMESHEET_ERROR:
            return {
                ...state,
                timesheetRequest: errorFetchingRequestState( action.error )
            };
        case FETCH_PROJECT_BY_ID_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error ),
            };
        case DELETE_PROJECT:
        case RESTORE_PROJECT:
            return {
                ...state,
                request: startFetchingRequestState()
            };
        case DELETE_PROJECT_SUCCESS:
        case RESTORE_PROJECT_SUCCESS:
            return {
                ...state,
                request: successFetchingRequestState()
            };
        case DELETE_PROJECT_ERROR:
        case RESTORE_PROJECT_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            };
        case UPDATE_PHASE_PERFORMANCE:
            return {
                ...state,
                request: startFetchingRequestState()
            };
        case UPDATE_PHASE_PERFORMANCE_SUCCESS: {
            const { phaseId, projectId, projectStageId } = action.phaseIdPath;

            return {
                ...state,
                detailedProjects: {
                    ...state.detailedProjects,
                    [ projectId.rawValue ]: {
                        ...state.detailedProjects[ projectId.rawValue ],
                        project: {
                            ...state.detailedProjects[ projectId.rawValue ]!.project,
                            resources: (
                                state.detailedProjects[ projectId.rawValue ]!.project.resources
                                .filter( _rs => isProjectStage( _rs ) ) as ProjectStage[]
                            ).map( _stage => {
                                    if( _stage.projectStageId.rawValue === projectStageId.rawValue ) {
                                        return {
                                            ..._stage,
                                            phases: (
                                                _stage.resources
                                                    .filter( _res => isProjectStagePhase( _res ) ) as ProjectStagePhase[]
                                            ).map( _phase => {
                                                if( _phase.phaseId.rawValue === phaseId.rawValue ) {
                                                    return {
                                                        ..._phase,
                                                        performance: action.performance
                                                    };
                                                } else {
                                                    return _phase;
                                                }
                                            } )
                                        };
                                    } else {
                                        return _stage;
                                    }
                                })
                        }
                    }
                },
                request: successFetchingRequestState()
            };

        }
        case UPDATE_PHASE_PERFORMANCE_ERROR:
            return {
                ...state,
                request: errorFetchingRequestState( action.error )
            };
        default:
            return state;
    }

}